import styled from "styled-components";

const HorizontalRule = styled.hr<any>`
  border: 0;
  height: 1px;
  background-color: ${(p) => p.backgroundColor || p.theme.colors.dark};
  margin: 1.2rem 0;
`;

export default HorizontalRule;
